<template>
  <OverlayLoader :visible="isLoading" />
  <div class="card bg-white border-0 rounded-3 mb-4">
    <div class="card-body p-0">
      <div
        class="d-flex row justify-content-center align-items-center flex-wrap gap-2 p-4"
      >
        <form class="position-relative table-src-form me-0" @submit.prevent>
          <div class="row">
            <div class="col-lg-12 col-sm-6 text-end">
              <div class="d-inline-flex flex-wrap gap-3 justify-content-end">
                <RouterLink :to="`/play-type/create/${idPlay}`">
                  <button
                    type="button"
                    class="btn btn-primary py-1 px-3 fw-medium fs-14 rounded-3 hover-bg"
                  >
                    <span class="py-sm-1 d-block">
                      <span>Agregar Acción</span>
                    </span>
                  </button>
                </RouterLink>

                <button
                  type="button"
                  @click="configurationPlayModal()"
                  class="btn btn-primary py-1 px-3 fw-medium fs-14 rounded-3 hover-bg"
                >
                  <span class="py-sm-1 d-block">
                    <span>Agregar del Archivo</span>
                  </span>
                </button>
                <RouterLink :to="`/plays`">
                  <button
                    type="button"
                    class="btn btn-primary py-1 px-3 fw-medium fs-14 rounded-3 hover-bg"
                  >
                    <span class="py-sm-1 d-block">
                      <span>Regresar</span>
                    </span>
                  </button>
                </RouterLink>
              </div>
            </div>
          </div>
        </form>
      </div>

      <div class="default-table-area style-two default-table-width">
        <div class="table-responsive">
          <table class="table align-middle">
            <thead>
              <tr>
                <th scope="col" class="text-center"></th>
                <th scope="col" class="text-center">Orden</th>
                <th scope="col" class="text-center">Tipo</th>
                <th scope="col" class="text-center">Detalle</th>
                <th scope="col" class="text-center">Tipo de Pregunta</th>
                <th scope="col" class="text-center">Nro. Opciones</th>
                <th scope="col" class="text-center">Fecha <br />asignación</th>
                <th scope="col" class="text-center">Opciones</th>
              </tr>
            </thead>
            <draggable
              v-if="items.length"
              v-model="items"
              item-key="id"
              tag="tbody"
              handle=".drag-handle"
              :animation="200"
              @end="updateOrderItems"
            >
              <template #item="{ element: item }">
                <tr :key="item.id">
                  <td class="text-body text-right drag-handle">
                    <i
                      class="material-symbols-outlined fs-16 text-primary cursor-move"
                      >drag_indicator</i
                    >
                  </td>
                  <td class="text-body text-right">{{ item.order }}</td>
                  <td class="text-body">{{ item.playType }}</td>
                  <td
                    v-html="limitHtmlContent(item.description)"
                    :title="stripHtmlAndLimit(item.description)"
                  ></td>
                  <td class="text-body text-center">
                    {{ item.questionType ?? "-" }}
                  </td>
                  <td class="text-body text-right">
                    {{ item.totalOptions ?? "-" }}
                  </td>
                  <td class="text-body">
                    {{ item.updatedAtDateTimeString ?? "-" }}
                  </td>
                  <td class="text-center">
                    <RouterLink
                      :to="`/play-type/${
                        item.playTypeId == PLAY_TYPES.QUIZ
                          ? 'question'
                          : 'content'
                      }/edit/${item.id}`"
                    >
                      <i class="material-symbols-outlined fs-16 text-primary">
                        edit
                      </i>
                    </RouterLink>
                    <button
                      class="ps-2 border-0 bg-transparent lh-1 position-relative"
                      @click="removedPlay(item.playTypeId, item.id)"
                    >
                      <i class="material-symbols-outlined fs-16 text-primary"
                        >delete</i
                      >
                    </button>
                  </td>
                </tr>
              </template>
            </draggable>
          </table>
        </div>
      </div>
    </div>
  </div>

  <!-- Modal -->
  <div
    id="mdlConfiguration"
    class="modal fade"
    tabindex="-1"
    aria-labelledby="mdlConfigurationLabel"
    aria-hidden="true"
    size="large"
  >
    <div class="modal-dialog modal-xl">
      <div class="modal-content">
        <div class="modal-header">
          <h1 class="modal-title fs-5" id="mdlConfigurationLabel">
            Repositorio de Jugadas
          </h1>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>
        <div class="modal-body">
          <div class="default-table-area style-two default-table-width">
            <div class="table-responsive">
              <table class="table align-middle">
                <thead>
                  <tr>
                    <th scope="col">#</th>
                    <th scope="col" class="text-center">Nombre de Jugada</th>
                    <th scope="col" class="text-center">Nro. Acciones</th>
                    <th scope="col" class="text-center">
                      Creado<br />
                      por
                    </th>
                    <th scope="col" class="text-center">
                      Fecha <br />creación
                    </th>
                    <th scope="col" class="text-center">Opciones</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in repository" :key="item.id">
                    <td>
                      {{ index + 1 }}
                    </td>
                    <td>{{ item.playName }}</td>
                    <td>{{ item.items.length }}</td>
                    <td class="text-body">{{ item.createdBy }}</td>
                    <td class="text-body">
                      {{ item.createdAtDateTimeString }}
                    </td>
                    <td class="text-center">
                      <div class="">
                        <button
                          class="ps-2 border-0 bg-transparent lh-1 position-relative"
                          @click="playActionsModal(item.id)"
                        >
                          <i
                            class="material-symbols-outlined fs-16 text-primary ps-2"
                          >
                            settings
                          </i>
                        </button>
                        <button
                          class="ps-2 border-0 bg-transparent lh-1 position-relative"
                          @click="assignPlay(item.id)"
                        >
                          <i
                            class="material-symbols-outlined fs-16 text-primary"
                          >
                            add
                          </i>
                        </button>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div class="p-4 pt-lg-4">
              <Pagination
                :currentPage="currentPage"
                :pageSize="pageSize"
                :totalItems="totalItems"
                @update:page="fetchPage"
              />
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-danger text-white"
            data-bs-dismiss="modal"
          >
            Cerrar
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, watch, toRefs, onMounted } from "vue";
import api from "@/services/api";
import { useToast } from "vue-toastification";
import { useRoute, useRouter } from "vue-router";
import htmlTruncate from "html-truncate";
import OverlayLoader from "@/components/Others/OverlayLoader.vue";
import { PAGINATION_ITEMS_PER_PAGE, PLAY_TYPES } from "@/utils/constants";
import Pagination from "@/components/Common/Pagination.vue";
import Swal from "sweetalert2";
import draggable from "vuedraggable";

export default defineComponent({
  name: "CreateConfigPlay",
  props: ["play", "getPlayConfig"],
  components: { Pagination, OverlayLoader, draggable },
  setup(props) {
    const currentPage = ref(1);
    const pageSize = ref(PAGINATION_ITEMS_PER_PAGE);
    const totalItems = ref(0);
    const toast = useToast();
    const route = useRoute();
    const router = useRouter();
    const isLoading = ref(false);
    const errors = ref<Record<string, string>>({});
    const modalConfiguration = ref<any>(null);
    const modalPlayActions = ref<any>(null);
    const repository = ref<any[]>([]);
    const idPlay = ref<any>(null);
    const filters = ref({
      playTypeId: null,
      name: "",
      isActive: null,
    });

    const { play } = toRefs(props);
    const items = ref<Array<any>>(
      props.play?.items ? [...props.play.items] : []
    );
    const playItems = ref<any[]>([]);

    onMounted(async () => {
      idPlay.value = route.params.id;

      const modalElement = document.getElementById("mdlConfiguration");
      if (modalElement && window.bootstrap) {
        modalConfiguration.value = new window.bootstrap.Modal(modalElement);
        modalConfiguration.value.hide();
      }

      const modalmdlPlayActionsElement =
        document.getElementById("mdlPlayActions");
      if (modalmdlPlayActionsElement && window.bootstrap) {
        modalPlayActions.value = new window.bootstrap.Modal(
          modalmdlPlayActionsElement
        );
        modalPlayActions.value.hide();
      }
    });
    const stripHtmlAndLimit = (html: string) => {
      const temp = document.createElement("div");
      temp.innerHTML = html;
      const text = temp.textContent || temp.innerText || "";
      return text;
    };

    const limitHtmlContent = (html: string, maxLength = 200) => {
      return htmlTruncate(html, maxLength, { keepImageTag: false });
    };

    const getPlaysRepository = async () => {
      try {
        isLoading.value = true;

        const response = await api.get(`/play/repository`);

        const dataItems = (response.data as { id: number }[]).filter(
          (f) => f.id !== Number(route.params.id)
        );

        repository.value = dataItems;
      } catch (error) {
        console.error(error);
      } finally {
        isLoading.value = false;
      }
    };

    const fetchPage = async () => {
      getPlaysRepository();
    };

    const configurationPlayModal = async () => {
      try {
        getPlaysRepository();
        modalConfiguration.value.show();
      } catch (ex) {
        console.error(ex);
      }
    };

    const assignPlay = async (playId: number) => {
      isLoading.value = true;

      var playIdToAssign = route.params.id;
      try {
        const payload = {
          PlayId: playId,
        };

        const response: any = await api.post(
          `/play/${playIdToAssign}/assign`,
          payload
        );
        isLoading.value = false;

        if (response.data) {
          props.getPlayConfig(playIdToAssign);
          toast.success(`La Jugada fue agregada con éxito.`, {
            timeout: 2000,
          });

          modalConfiguration.value.hide();
        }
      } catch (ex) {
        toast.error("La Jugada no pudo ser agregada.", {
          timeout: 2000,
        });
        console.error(ex);
        isLoading.value = false;
      }
    };

    const removedPlay = async (playTypeId: number, id: number) => {
      const result = await Swal.fire({
        html: `¿Estás seguro que deseas <b>desactivar</b> la Jugada?`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: `Sí, desactivar`,
        cancelButtonText: "Cancelar",
      });

      if (result.isConfirmed) {
        isLoading.value = true;

        var playId = route.params.id;
        const payload = {
          playTypeId: playTypeId,
          id: id,
        };

        const response: any = await api.post(`/play/${playId}/remove`, payload);

        if (response != 0) {
          await props.getPlayConfig(playId);
          await updateOrderItems();
          toast.success(`La Jugada fue desactivada con éxito.`, {
            timeout: 3000,
          });
        } else {
          toast.error(`La Jugada no pudo ser desactivada.`, {
            timeout: 3000,
          });
        }
        isLoading.value = false;
      }
    };

    watch(
      () => play.value.items,
      (newItems) => {
        items.value = Array.isArray(newItems) ? [...newItems] : [];
      },
      { immediate: true }
    );

    const updateOrderItems = async () => {
      items.value.forEach((item, index) => {
        item.order = index + 1;
      });

      isLoading.value = true;

      var playId = route.params.id;
      try {
        const response: any = await api.put(
          `/play/${playId}/update-order`,
          items.value
        );
        isLoading.value = false;

        if (response.data) {
          toast.success(`Se actualizó el orden de las jugadas.`, {
            timeout: 3000,
          });
        }
      } catch (ex) {
        toast.error("El orden de las jugadas no pudo ser actualizado.", {
          timeout: 2000,
        });
        console.error(ex);
        isLoading.value = false;
      }
    };

    const getPlayConfig = async (id: any) => {
      try {
        isLoading.value = true;

        const response = await api.get(`/play/${id}/config`);
        return response;
      } catch (error) {
        console.error(error);
      } finally {
        isLoading.value = false;
      }
    };
    const playActionsModal = async (id: number) => {
      try {
        play.value = items.value.find((f) => f.id === id);

        const response = await getPlayConfig(id);
        if (response != null) {
          playItems.value = response.data.items;
        }

        modalPlayActions.value.show();
      } catch (ex) {
        console.error(ex);
      }
    };

    return {
      errors,
      isLoading,
      repository,
      filters,
      currentPage,
      pageSize,
      totalItems,
      OverlayLoader,
      Pagination,
      stripHtmlAndLimit,
      limitHtmlContent,
      fetchPage,
      configurationPlayModal,
      assignPlay,
      removedPlay,
      draggable,
      updateOrderItems,
      items,
      idPlay,
      PLAY_TYPES,
      playItems,
      playActionsModal,
    };
  },
});
</script>
